<div class="holder">
  <div  (click)="navigate('/fine')">Bötfäll</div>
  <div (click)="navigate('/receive')">Hämta</div>
  <div  (click)="navigate('/register')">Registera</div>
</div>
